import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Input,
  Output
} from '@angular/core';
import { PeriodSelection } from '../period-selection/period-selection.enum';
import { Period } from '../period-selection/period';
import { MatDialog } from '@angular/material/dialog';
import { PeriodSelectionDialogComponent } from '../period-selection-dialog/period-selection-dialog.component';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Directionality } from '@angular/cdk/bidi';
import { NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault, DatePipe } from '@angular/common';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'pcp-period-selection-button',
    templateUrl: './period-selection-button.component.html',
    styleUrls: ['./period-selection-button.component.scss'],
    imports: [NgIf, MatButton, MatIcon, NgSwitch, NgSwitchCase, NgSwitchDefault, DatePipe]
})
export class PeriodSelectionButtonComponent implements OnInit, OnDestroy {
  constructor(public dialog: MatDialog, private dir: Directionality) {}
  periodSelection = PeriodSelection;
  private onDestroy$ = new Subject<void>();
  @Input() icon: string | null = null;
  @Input() value: Period | null = null;
  @Output() valueChange = new EventEmitter<Period>();
  ngOnInit() {}

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  setTime() {
    const data = this.value;
    this.dialog
      .open(PeriodSelectionDialogComponent, { data, direction: this.dir.value })
      .afterClosed()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((result: Period) => {
        if (result) {
          this.value = result;
          this.valueChange.emit(this.value);
        }
      });
  }
}
